import { makeAutoObservable } from "mobx";
import { IRootStore } from "./RootStore";
import { OrganizationType } from "../components/main/body/screens/IAM/Users/types/OrganizationType";
import { UserType } from "../components/main/body/screens/IAM/Users/types/UserType";

interface Aircraft {
    id: number;
    airCraftType: string;
  }  

  interface WifiProvider {
    id: number;
    wifiProvider: string;
  } 


type singleFlight = {
    Id: string;
    planeLandedStatus: string;
    tailNumber: number;
    departurePlace: string;
    arrivalPlace: string;
    diversionDecisionStatus: string;
    dispositionStatus: string;
    organization: {id: number;name: string;providedInformation: []};
    captain: string;
    roomId: string;
    internetStatus: string;
    crews: string;
    registeredEmails: string;
    schedDepTime: string;
    schedArvTime: string;
    actualDepTime: string;
    actualArvTime: string;
    lastSeen: string;
    msn: number;
    fleetType: string;
    wifiProvider: string;
    createdAt: string;
    aircraftList: Aircraft[];
    wifiProviderList : WifiProvider[];

    
}
export class FlightsStore {

    historySearchString = [];
    flights=[];
    SpecificFlights:singleFlight | null = null;
    Id: string="";
    msn : number | null = null;
    TailNumber: number | null = null;
    FleetType : string="";
    WifiProvider : string="";
    EditFlightOrgList: OrganizationType[] = [];
    Org : string = "";
    update : number = 0;
    AddOrg : string = '';
    orgid : string="";
    orgList: OrganizationType[] = [];
    userOId: string = "";
    originalUser: UserType[] = [];
    user: UserType[] = [];
    flightID: string = "";
    aircraftList: Aircraft[] = [];
    wifiProviderList: WifiProvider[] = [];



    rootStore: IRootStore;

    constructor(rootStore: IRootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    handleflightlist(list : any){
        this.historySearchString = list;
    }

    get getFlightlist(){
       return this.historySearchString;
    }
    handleSpecificFlights(list : any){
        this.SpecificFlights= list;
    }

    get getSpecificFlights(){
       return this.SpecificFlights;
    }
    
    handleId(Id : string){
        this.Id= Id;
    }

    get getId(){ 
       return this.Id;
    }

    handleMsn(Msn : number | null){
        this.msn= Msn;
    }

    get getMsn(){ 
       return this.msn;
    }
    handleTailNumber(TailNumber : number){
        this.TailNumber= TailNumber;
    }

    get getTailNumber(){ 
       return this.TailNumber;
    }
    handleFleetType(FleetType : string){
        this.FleetType= FleetType;
    }

    get getFleetType(){ 
       return this.FleetType;
    }
    handleWifiProvider(WifiProvider : string){
        this.WifiProvider= WifiProvider;
    }

    get getWifiProvider(){ 
       return this.WifiProvider;
    }
    handleEditFlightOrgList = (list: OrganizationType[]) => {
        this.EditFlightOrgList = list;
    }
    get getEditFlightOrgList() {
        return this.EditFlightOrgList;
    }
    
    handleOrg = (Org: string) => {
        this.Org = Org;
    }
    get getOrg() {
        return this.Org;
    }
    handleAddOrg = (AddOrg: string) => {
        this.AddOrg = AddOrg;
    }
    get getAddOrg() {
        return this.AddOrg;
    }
    handleupdate = () => {
        this.update++;
    }
    get getupdate () {
        return this.update ;
    }

    setSelectedOrd = (orgidset:string) => {
        this.orgid=orgidset;
    }
    get getSelectedOrd () {
        return this.orgid ;
    }
  
    handleOrgList = (organization: OrganizationType[]) => {
        this.orgList = organization;
    }
    get getOrgList() {
        return this.orgList;
    }

    handleFlightList = (aircraftList : Aircraft[] ) =>{
        this.aircraftList = aircraftList
    }
    get getFlightList () {
        return this.aircraftList
    }

    handleWifiProviderList = (wifiProvider : WifiProvider[] ) =>{
        this.wifiProviderList = wifiProvider
    }
    get getWifiProviderList () {
        return this.wifiProviderList
    }
    
    handleUserOId = (OId: string) => {
        this.userOId = OId;
    }
    get getUserOId() {
        return this.userOId;
    }
    handleOriginalUser = (user : UserType[]) => {
        this.originalUser = user;
    }
    get getOriginalUser() {
        return this.originalUser;
    }
    handleUser = (user:   UserType[]) => {
        this.user = user;
    }
    get getUser() {
        return this.user;
    }
    handleflightID = (flightID: string) => {
        this.flightID = flightID;
    }
    get getflightID() {
        return this.flightID;
    }
  

}

 